import { h, Component } from "preact";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import InputField from "./fields/InputField";
import { addGiftCard, removeGiftCard } from "../state/actions/orderActions";
import ActionButton from "./ActionButton";
import crossIcon from "../assets/images/icon-cross.svg";
import successIcon from "../assets/images/icon-success.svg";

class GiftCardCode extends Component {
  save = values => {
    const { addGiftCard, order, event } = this.props;
    const code = values.giftCardCode;
    if (code) {
      addGiftCard(event.data._id, order.data._id, code);
    }
  };

  remove = () => {
    const { removeGiftCard, order } = this.props;
    removeGiftCard(order.data._id);
  };

  render() {
    const { event, order, allowAdd = true, handleSubmit } = this.props;

    if (!event || !event.data || !event.data.hasGiftCards) {
      return null;
    }

    const discountCodeStyle = {
      background: `url(${successIcon}) no-repeat left 5px center`,
      backgroundSize: 20,
      color: "#1bab74",
      margin: "0px 12px",
      padding: "4px 0 4px 28px",
      display: "inline-block"
    };
    const removeStyle = {
      background: `url(${crossIcon}) no-repeat right 5px center`,
      backgroundSize: 20,
      paddingLeft: 30,
      cursor: "pointer",
      float: "right",
      height: 30
    };
    const giftCardCode =
      order.data.giftCard && order.data.giftCard.code
        ? order.data.giftCard.code
        : false;
    const discountStyle = { paddingTop: 12, paddingBottom: 12 };
    let giftCardDisplay = false;
    if (allowAdd && giftCardCode) {
      giftCardDisplay = (
        <span>
          Gift card code: <span style={discountCodeStyle}>{giftCardCode}</span>
          <a onClick={this.remove} style={removeStyle} />
        </span>
      );
    }

    if (!allowAdd && giftCardCode) {
      giftCardDisplay = <span>Discount code: {giftCardCode}</span>;
    }

    if (giftCardDisplay) {
      return <div style={discountStyle}>{giftCardDisplay}</div>;
    }

    return allowAdd && event && event.data ? (
      <div style={discountStyle}>
        {order.giftCardsRequest.error ? (
          <p class="text-error error-icon">{order.giftCardsRequest.error}</p>
        ) : (
          ""
        )}
        <form onSubmit={handleSubmit(this.save)}>
          <div style={{ display: "flex" }}>
            <Field
              style={{
                width: "80%"
              }}
              inputStyle={{
                borderRadius: "4px 0 0 4px"
              }}
              type="text"
              name="giftCardCode"
              label="Enter gift card code"
              component={InputField}
              placeholder="Gift card code"
            />
            <ActionButton
              loading={order.giftCardsRequest.loading}
              classNames="btn-secondary"
              dataCY="GiftCardCodeApply"
              style={{
                borderRadius: "0 4px 4px 0",
                padding: "4px 10px",
                marginTop: 24
              }}
            >
              Apply
            </ActionButton>
          </div>
        </form>
      </div>
    ) : (
      ""
    );
  }
}

GiftCardCode = reduxForm({
  form: "giftCard"
})(GiftCardCode);

export default connect(
  (state, ownProps) => ({
    event: state.event,
    order: state.order
  }),
  { addGiftCard, removeGiftCard }
)(GiftCardCode);



// WEBPACK FOOTER //
// ./components/GiftCardCode.js